/**
 * TeamSystem Impact - User Assignments Hook
 *
 * Carica le assegnazioni attive dell'utente corrente per l'anno di lavoro.
 * Usato da AppSidebar per mostrare/nascondere voci di menu per i contributori.
 * Se la fetch fallisce, ritorna { false, false } — il sidebar non crasha.
 */

import { useState, useEffect } from 'react';
import { apiClient } from '../../../api/client';
import { useWorkingYear } from '../../../store/workingYearStore';

export interface UserAssignments {
  hasOwnerAssignments: boolean;
  hasSupervisorAssignments: boolean;
  ownerToDoCount: number;
  supervisorToDoCount: number;
}

const FALLBACK: UserAssignments = {
  hasOwnerAssignments: false,
  hasSupervisorAssignments: false,
  ownerToDoCount: 0,
  supervisorToDoCount: 0,
};

export function useUserAssignments(): UserAssignments {
  const { year } = useWorkingYear();
  const [data, setData] = useState<UserAssignments>(FALLBACK);

  useEffect(() => {
    let cancelled = false;

    apiClient
      .get<{ success: boolean; data: UserAssignments }>(
        `/data-capture/assignments/my?assessmentYear=${year}`
      )
      .then((res) => {
        if (!cancelled && res.data?.data) {
          setData({ ...FALLBACK, ...res.data.data });
        }
      })
      .catch(() => {
        // Non crashare — usa fallback { false, false }
      });

    return () => {
      cancelled = true;
    };
  }, [year]);

  return data;
}
